import { Autocomplete, createFilterOptions, TextField } from '@mui/material';

const selectionOptionFilter = createFilterOptions<SelectionType>();

interface SelectionType {
  id: string;
  name: string;
  lastName?: string;
  primaryPhone?: string;
  email?: string;
}

interface ResourceSelectorProps {
  autoCompleteType: 'Employee' | 'Equipment' | 'Contractor';
  autoCompleteId: string;
  selection: SelectionType;
  resourceList: SelectionType[];
  setSelection: React.Dispatch<React.SetStateAction<SelectionType>>;
}

const OverwatchResourceSelector: React.FC<ResourceSelectorProps> = ({
  autoCompleteId,
  selection,
  resourceList,
  setSelection,
  autoCompleteType,
}) => {
  return (
    <>
      <Autocomplete
        id={autoCompleteId}
        value={selection as SelectionType}
        options={[...resourceList]}
        autoHighlight
        freeSolo
        selectOnFocus
        clearOnBlur
        disableClearable
        handleHomeEndKeys
        fullWidth
        onChange={(_, newValue) => {
          if (typeof newValue !== 'string' && newValue && newValue.id) {
            // Create a new value from the user input
            const firstName = newValue.name.replace('Add "', '');
            const lastName = newValue.lastName?.replace('"', '');

            setSelection({
              id: newValue.id,
              name: firstName,
              lastName: lastName,
            });
          }
        }}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option.trim();
          } else {
            return `${option.name?.trim() || ''} ${option.lastName?.trim() || ''}`.trim();
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={`${autoCompleteType} to schedule`}
            error={selection.id !== '' && autoCompleteType === 'Employee' && (selection.name?.length || 0) < 3}
            helperText={
              selection.id !== '' && autoCompleteType === 'Employee' && (selection.name?.length || 0) < 3
                ? 'Full name is required'
                : ''
            }
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: 'new-password', // disable autocomplete and autofill
              },
            }}
          />
        )}
        filterOptions={(options, params) => {
          const filtered = selectionOptionFilter(options, params);

          return filtered;
        }}
      />
    </>
  );
};

export default OverwatchResourceSelector;
